import memoryBoostCreateVideo_EN from '../assets/graphics/video/JOYAJOY_AIMemoryBooster-Guide_v5_EN_20250207v1_small.mp4';
import memoryBoostCreateVideo_TC from '../assets/graphics/video/JOYAJOY_AIMemoryBooster-Guide_v5_TC_20250207v1_small.mp4';
import memoryBoostVideo_EN from '../assets/graphics/video/JOYAJOY_AIMemoryBooster-Promo_v5_EN_20250207v1_small.mp4';
import memoryBoostVideo_TC from '../assets/graphics/video/JOYAJOY_AIMemoryBooster-Promo_v5_TC_20250207v1_small.mp4';
import JOYAJOY_CaseStudy_SC from '../assets/graphics/video/JOYAJOY_AIRev_CaseStudy_v2_SC_20241203v1_small.mp4';
import JOYAJOY_CaseStudy_TC from '../assets/graphics/video/JOYAJOY_AIRev_CaseStudy_v2_TC-HK_20241202v5_small.mp4';
import JOYAJOY_CreateGame_EN from '../assets/graphics/video/JOYAJOY_CreateGame_v5_EN_20241112v1_small.mp4';
import JOYAJOY_CreateGame_SC from '../assets/graphics/video/JOYAJOY_CreateGame_v5_SC_20241112v1_small.mp4';
import JOYAJOY_CreateGame_TC from '../assets/graphics/video/JOYAJOY_CreateGame_v5_TC_20241112v1_small.mp4';
import JOYAJOY_GuaranteedLearning_EN from '../assets/graphics/video/JOYAJOY_GuaranteedLearning_v5_EN-US_20241129v1_small.mp4';
import JOYAJOY_GuaranteedLearning_SC from '../assets/graphics/video/JOYAJOY_GuaranteedLearning_v5_SC_20241113v1_small.mp4';
import JOYAJOY_GuaranteedLearning_TC from '../assets/graphics/video/JOYAJOY_GuaranteedLearning_v5_TC-TW_20241112v1_small.mp4';
import bibleBoostCreateVideo_EN from '../assets/graphics/video/JOYAJOY-ArkWord_BibleMemoryBooster-Guide_v7_EN_20250207v1_small.mp4';
import bibleBoostCreateVideo_TC from '../assets/graphics/video/JOYAJOY-ArkWord_BibleMemoryBooster-Guide_v7_TC_20250207v1_small.mp4';
import bibleBoostVideo_EN from '../assets/graphics/video/JOYAJOY-ArkWord_BibleMemoryBooster-Promo_v6_EN_20250207v1_small.mp4';
import bibleBoostVideo_TC from '../assets/graphics/video/JOYAJOY-ArkWord_BibleMemoryBooster-Promo_v6_TC_20250207v1_small.mp4';
import { UiLocale } from '../models/Base';

export const Videos = {
  //JOYAJOY
  JOYAJOY_CreateGame_EN,
  JOYAJOY_CreateGame_SC,
  JOYAJOY_CreateGame_TC,
  JOYAJOY_GuaranteedLearning_EN,
  JOYAJOY_GuaranteedLearning_SC,
  JOYAJOY_GuaranteedLearning_TC,
  JOYAJOY_CaseStudy_TC,
  JOYAJOY_CaseStudy_SC,
  memoryBoostVideo_EN,
  memoryBoostVideo_TC,
  bibleBoostVideo_EN,
  bibleBoostVideo_TC,
  memoryBoostCreateVideo_EN,
  memoryBoostCreateVideo_TC,
  bibleBoostCreateVideo_EN,
  bibleBoostCreateVideo_TC,
};

export const getCreateGameVideo = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
      return Videos.JOYAJOY_CreateGame_SC;
    case UiLocale.HK:
    case UiLocale.TW:
      return Videos.JOYAJOY_CreateGame_TC;
    case UiLocale.JP:
      return Videos.JOYAJOY_CreateGame_EN;
    case UiLocale.US:
    default:
      return Videos.JOYAJOY_CreateGame_EN;
  }
};

export const getMemoryBoostVideo = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.TW:
    case UiLocale.HK:
    case UiLocale.CN:
      return Videos.memoryBoostVideo_TC;
    case UiLocale.JP:
    case UiLocale.US:
    default:
      return Videos.memoryBoostVideo_EN;
  }
};

export const getBibleBoostVideo = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.TW:
    case UiLocale.HK:
    case UiLocale.CN:
      return Videos.bibleBoostVideo_TC;
    case UiLocale.JP:
    case UiLocale.US:
    default:
      return Videos.bibleBoostVideo_EN;
  }
};

export const getMemoryBoostCreateVideo = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.TW:
    case UiLocale.HK:
    case UiLocale.CN:
      return Videos.memoryBoostCreateVideo_TC;
    case UiLocale.JP:
    case UiLocale.US:
    default:
      return Videos.memoryBoostCreateVideo_EN;
  }
};

export const getBibleBoostCreateVideo = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.TW:
    case UiLocale.HK:
    case UiLocale.CN:
      return Videos.bibleBoostCreateVideo_TC;
    case UiLocale.JP:
    case UiLocale.US:
    default:
      return Videos.bibleBoostCreateVideo_EN;
  }
};

export const getGuaranteedLearningVideo = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
      return Videos.JOYAJOY_GuaranteedLearning_SC;
    case UiLocale.HK:
    case UiLocale.TW:
      return Videos.JOYAJOY_GuaranteedLearning_TC;
    case UiLocale.JP:
      return Videos.JOYAJOY_GuaranteedLearning_EN;
    case UiLocale.US:
    default:
      return Videos.JOYAJOY_GuaranteedLearning_EN;
  }
};

export const getVideoCustomName = (
  lang: UiLocale,
  name: string,
): string | undefined => {
  let code = '';
  switch (lang) {
    case UiLocale.CN:
      code = 'SC';
      break;
    case UiLocale.HK:
    case UiLocale.TW:
      code = 'TC';
      break;
    case UiLocale.JP:
      code = 'JP';
      break;
    case UiLocale.US:
    default:
      code = 'EN';
      break;
  }
  const videoName = `${name}_${code}`;
  return (
    (Videos as Record<string, string>)[videoName] ||
    (Videos as Record<string, string>)[`${name}_EN`] ||
    undefined
  );
};
